import { AxiosInstance } from 'axios'
import { Permission, PermissionUpdate, PaginatedResponse, ListPermissionsParams } from './permission.type'

export class PermissionApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all permissions with pagination
     */
    async list(params?: ListPermissionsParams): Promise<PaginatedResponse<Permission>> {
        const response = await this.client.get<PaginatedResponse<Permission>>('/permissions', {
            params,
        })
        return response.data
    }

    /**
     * Get a single permission by ID
     */
    async findOne(id: string): Promise<Permission> {
        const response = await this.client.get<Permission>(`/permissions/${id}`)
        return response.data
    }

    /**
     * Get current user's permissions
     */
    async getMyPermissions(params?: ListPermissionsParams): Promise<PaginatedResponse<Permission>> {
        const response = await this.client.get<PaginatedResponse<Permission>>('/permissions/me', {
            params,
        })
        return response.data
    }

    /**
     * Update a permission
     */
    async update(id: string, payload: PermissionUpdate): Promise<Permission> {
        const response = await this.client.put<Permission>(`/permissions/${id}`, payload)
        return response.data
    }

    /**
     * Delete a permission (soft delete)
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/permissions/${id}`)
    }
}
